<template>
  <button
      class="upload__button"
      :class="classButton"
      :disabled="isButtonDisabled"
      @click="$emit('publish')">
    <slot>
      {{ $t('stepPublishButton.slotText') }}
    </slot>
    <slot name="icon">
      <span class="glyphicon glyphicon-arrow-right upload__icon" aria-hidden="true"></span>
    </slot>
  </button>
</template>

<script>
export default {
  name: "StepPublishButton",
  props: {
    isButtonDisabled: Boolean,
  },
  computed: {
    classButton() {
      return {
        'text-primary': !this.isButtonDisabled && !this.$store.state.isHkom,
        'text-primary--green': !this.isButtonDisabled && this.$store.state.isHkom,
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/sass/abstracts/variables_shared.scss";

.upload {
  &__button {
    border: none;
    outline: none;
    float: right;

    border-radius: 1.3px;
    background-color: #ffffff;
    box-shadow: $box-shadow;
    padding: 7px 16px;
    cursor: pointer;
    color: #c0c0c0;
    font-size: 14px;
    font-weight: 600;

    &:hover:not(:disabled) {
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3);
      transform: translateY(1px);
    }

    @media (max-width: 768px) {
      padding: 8px 9px;
      float: none;
      width: 100%;
    }

  }
  &__icon {
    margin-left: 5px;
    color: #5e5d5d;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/step/StepPublishButton.vue